import { render, staticRenderFns } from "./modelItemData.vue?vue&type=template&id=15173dc8&scoped=true&"
import script from "./modelItemData.vue?vue&type=script&lang=js&"
export * from "./modelItemData.vue?vue&type=script&lang=js&"
import style0 from "./modelItemData.vue?vue&type=style&index=0&id=15173dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15173dc8",
  null
  
)

export default component.exports